import React from "react";
import styled from "styled-components";

import { Edit } from "./Edit";
import { Preview } from "./Preview";
import { ModeSwitch } from "./ModeSwitch";

const StyledWrapper = styled.div`
  background-color: white;
  border-radius: 4px;
  border 0.5px solid lightgray;
`;

export const Editor = (props) => {
  const [mode, setMode] = React.useState();
  const [value, setValue] = React.useState(props.defaultValue);

  React.useEffect(() => {
    if (value === props.defaultValue) {
      return;
    }

    setValue(props.defaultValue);
  }, [props.defaultValue]);

  const handleChange = (newValue) => {
    setValue(newValue);
    props.onChange(newValue);
  };

  return (
    <>
      <ModeSwitch mode={mode} onChange={setMode} />
      <StyledWrapper>
        <Preview
          mode={mode}
          toolbar={props.previewToolbar}
          editorState={props.defaultValue}
          onEditorStateChange={handleChange}
        />
        <Edit mode={mode} editorState={value} onEditorStateChange={handleChange} />
      </StyledWrapper>
    </>
  );
};
